export enum MinerShippingStatus {
  AssignedToOutboundContainer = 'Assigned to Outbound Container',
  UnassignedToOutboundContainer = 'Unassigned to Outbound Container',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
}
